import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "../lib/api";
import { Seo } from "../components/site/Seo";
import { Reveal } from "../components/site/Reveal";
import { ServiceHero, SectionHeading, CheckList } from "../components/site/ServiceHero";
import { CTABand } from "../components/site/CTABand";
import { LeadForm } from "../components/site/LeadForm";
import { EQUIPMENT, DISPATCH_SERVICES } from "../data/content";

export default function Dispatch() {
  return (
    <div data-testid="dispatch-page">
      <Seo title="Truck Dispatch Services — New MC Authorities Welcome" description="Professional truck dispatch services at 9% of gross load revenue. Load searching, rate negotiation, broker relationships, and load tracking for box trucks, flatbeds, and semi trucks." />
      <ServiceHero eyebrow="Dispatch Services" title="KEEP YOUR TRUCK MOVING." highlight="PROTECT YOUR RATE."
        subtitle="We handle the load boards, broker calls, and rate negotiation so you can focus on driving and growing."
        image={IMAGES.nightSemi} price="9% OF GROSS LOAD REVENUE" />

      <section className="relative py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="nm-card rounded-2xl p-8 border-l-4 border-[#10B981] mb-16">
              <p className="font-head text-2xl font-bold text-white mb-3">NEW MC AUTHORITIES ARE WELCOME.</p>
              <p className="text-gray-400 leading-relaxed max-w-3xl">
                We understand new carriers may initially have fewer broker options. Our team works to identify available opportunities,
                develop broker relationships, negotiate rates, and help you establish your freight history — so you can build momentum from day one.
              </p>
            </div>
          </Reveal>

          <SectionHeading eyebrow="Equipment we dispatch" className="mb-10">WE MOVE EVERY <span className="nm-gold-text">TYPE OF FREIGHT.</span></SectionHeading>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-20">
            {EQUIPMENT.map((e, i) => (
              <Reveal key={e.name} delay={i * 0.08}>
                <motion.div whileHover={{ y: -6 }} className="group relative rounded-2xl overflow-hidden h-56" data-testid={`equipment-${i}`}>
                  <img src={IMAGES[e.key]} alt={e.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#060A17] via-[#060A17]/30 to-transparent" />
                  <p className="absolute bottom-4 left-4 font-head text-lg font-bold text-white">{e.name}</p>
                </motion.div>
              </Reveal>
            ))}
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              <SectionHeading eyebrow="What's included" className="mb-8">SERVICES INCLUDE</SectionHeading>
              <CheckList items={DISPATCH_SERVICES} />
              <Reveal>
                <div className="mt-8 nm-card rounded-xl p-6">
                  <p className="font-head text-lg font-bold nm-gold-text">Dispatch Fee: 9% of gross load revenue</p>
                  <p className="text-gray-400 text-sm mt-2">Dispatch fees are calculated and paid weekly based on loads handled by Next Mile Compliance.</p>
                </div>
              </Reveal>
            </div>
            <div className="lg:sticky lg:top-28">
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Start dispatch services</p>
              <LeadForm source="dispatch" defaultService="Dispatch Services" submitLabel="START DISPATCH SERVICES" />
            </div>
          </div>
        </div>
      </section>

      <CTABand eyebrow="Need loads? Let's talk." title="Protect your rate. Keep your truck moving." button="START DISPATCH SERVICES" />
    </div>
  );
}
